import { Outlet } from "react-router-dom";

export const SettingsLayout = () => (
    <div className="mx-auto max-w-[1440px] pb-8">
        <main className="min-w-0">
            <Outlet />
        </main>
    </div>
);
